import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21440921"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Report" }
const _hoisted_2 = { class: "textArea" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "举报内容:", -1))
const _hoisted_4 = { class: "upload" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "上传图片:", -1))
const _hoisted_6 = { class: "uploadWarpper" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("举报")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanRadio = _resolveComponent("VanRadio")!
  const _component_VanCell = _resolveComponent("VanCell")!
  const _component_VanRadioGroup = _resolveComponent("VanRadioGroup")!
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_VanUploader = _resolveComponent("VanUploader")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanRadioGroup, {
      modelValue: $setup.reportData.reportTerm,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.reportData.reportTerm) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportType, (item, idx) => {
          return (_openBlock(), _createBlock(_component_VanCell, {
            title: item.text,
            clickable: "",
            key: idx,
            onClick: ($event: any) => ($setup.reportData.reportTerm = item.id)
          }, {
            "right-icon": _withCtx(() => [
              _createVNode(_component_VanRadio, {
                name: item.id,
                "checked-color": "#19be6e"
              }, null, 8, ["name"])
            ]),
            _: 2
          }, 1032, ["title", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_VanField, {
        type: "textarea",
        modelValue: $setup.reportData.contents,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.reportData.contents) = $event)),
        placeholder: "请输入举报内容",
        autosize: "",
        rows: "3",
        maxlength: "200",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imgList, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "imgItem",
            key: `img${idx}`
          }, [
            _createVNode(_component_VanImage, {
              src: item.img,
              style: {"width":"100%","height":"100%"}
            }, null, 8, ["src"]),
            _createElementVNode("div", {
              class: "close",
              onClick: ($event: any) => ($setup.closeImg(idx))
            }, [
              _createVNode(_component_van_icon, {
                name: "cross",
                color: "white"
              })
            ], 8, _hoisted_7)
          ]))
        }), 128)),
        _createVNode(_component_VanUploader, {
          multiple: "",
          "after-read": $setup.afterRead
        })
      ]),
      _createElementVNode("span", {
        style: {"color":"red"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toKefu()))
      }, "若发布失败，图片上传失败，请点击这里查看")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_VanButton, {
        block: "",
        style: {"background-color":"#33AC9C","color":"#FFF"},
        onClick: $setup.submit,
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ]))
}